import Swal from "sweetalert2";
import { fetchConToken, fetchSinToken } from "../../helpers/fetch";
import { types } from "../../types/types";
import { getLocalStorage, setLocalStorage } from "../../helpers/localStorage";
import { setUserCity } from "../ui/ui";

export const startLogin = (email, password) => {
  return async (dispatch) => {
    const resp = await fetchSinToken(
      "api/users/login",
      { email, password },
      "POST"
    );
    const body = await resp.json();

    if (body.status === 200) {
      const token = body.data.token;
      setLocalStorage("token-adm", token);
      setLocalStorage("token-init-date", new Date().getTime());

      const rpta = await fetchConToken("api/users/get/admin", {}, "GET");
      const body2 = await rpta.json();
      if (body2.status === 200) {
        const { id, name, role, is_super_admin, city_id, jugnoId } = body2.data;
        dispatch(
          login({
            uid: id,
            name,
            role,
            isSuperAdmin: is_super_admin,
            cityId: city_id,
            jugnoId,
          })
        );
        if (city_id) {
          dispatch(setUserCity(city_id));
        }
      } else {
        Swal.fire({
          title: "Error!",
          text: body.message,
          icon: "error",
        });
      }
    } else {
      Swal.fire({
        title: "Error!",
        text: body.message,
        icon: "error",
      });
    }
  };
};

const login = (user) => ({
  type: types.authLogin,
  payload: user,
});

export const startLogout = () => {
  return (dispatch) => {
    localStorage.clear();
    dispatch(logout());
  };
};

const logout = () => ({
  type: types.authLogout,
});

export const startChecking = () => {
  return async (dispatch) => {
    const token = getLocalStorage("token-adm");
    if (token) {
      const rpta = await fetchConToken("api/users/get/admin", {}, "GET");
      const body = await rpta.json();
      if (body.status === 200) {
        const { id, name, role, city_id, jugnoId } = body.data;
        dispatch(
          login({
            uid: id,
            name,
            role,
            isSuperAdmin: body.data.is_super_admin,
            cityId: city_id,
            jugnoId,
          })
        );
        if (city_id) {
          dispatch(setUserCity(city_id));
        }
      } else {
        dispatch(checkingFinish());
      }
    }
  };
};

const checkingFinish = () => ({
  type: types.authCheckingFinish,
});

export const putUser = async ({ id, params }) => {
  const rpta = await fetchConToken(`api/users/${id}`, params, "PUT");
  const body = await rpta.json();
  return body;
};
